
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as StudentViewIconComponent } from "./student-view-icon.svg";

export const StudentViewIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <StudentViewIconComponent {...props} />;
};
